import Api from "@/services/Api";

let controller = "games";

export default {
  index() {
    return Api().get(controller);
  },
  store(form) {
    return Api().post(controller, form);
  },
  view(gameId) {
    return Api().get(`${controller}/${gameId}`);
  },
  delete(gameId) {
    return Api().delete(`${controller}/${gameId}`);
  },
  setGamePackSelection(gameId, gamePackSelection) {
    return Api().put(`${controller}/${gameId}`, {
      game_pack_selection: gamePackSelection
    });
  },
  fillReserve(gameId) {
    return Api().get(`${controller}/${gameId}/fill_reserve`);
  },
  discardCard(gameId, cardBackId) {
    return Api().delete(`${controller}/${gameId}/discard_card/${cardBackId}`);
  },
  detachCard(gameId, cardBackId) {
    return Api().delete(`${controller}/${gameId}/detach_card/${cardBackId}`);
  },
  join(gameId, inviteCode) {
    return Api().get(`${controller}/${gameId}/join/${inviteCode}`);
  },
  setReserveSlots(gameId, reserveSlots) {
    return Api().put(`games/${gameId}/set_reserve_slots`, {
      reserve_slots: reserveSlots
    });
  }
};
